import { memo, ReactNode } from 'react'

import { useRouter } from 'next/router'

import { DataLayerProps } from 'models/data-layer'
import { buildSimulatorUrl } from 'utils/buildSimulatorUrl'
import { pushDataLayer } from 'utils/push-data-layer'

import * as S from './styles'

type Props = {
  children: ReactNode
  dataLayer: DataLayerProps
  medium: string
}

export const SimulatorLink = memo(({ children, dataLayer, medium }: Props) => {
  const router = useRouter()

  const handleClick = () => {
    pushDataLayer(dataLayer)
    location.href = buildSimulatorUrl(router.pathname, { medium })
  }

  return (
    <S.InlineButton type="button" onClick={handleClick}>
      {children}
    </S.InlineButton>
  )
})

SimulatorLink.displayName = 'SimulatorLink'
